/**
 * phone_carrier: 手機條碼,
 * donate_invoice: 捐贈發票,
 * business_einvoice: 營業用電子發票,
 * non_business_einvoice: 非營業用電子發票
 */
export enum Invoice {
  NON_BUSINESS_EINVOICE = 'non_business_einvoice',
  BUSINESS_EINVOICE = 'business_einvoice',
  PHONE_CARRIER = 'phone_carrier',
  DONATE_INVOICE = 'donate_invoice',
}

export const InvoiceMap: Record<Invoice, string> = {
  [Invoice.NON_BUSINESS_EINVOICE]: '非營業用電子發票',
  [Invoice.BUSINESS_EINVOICE]: '營業用電子發票',
  [Invoice.PHONE_CARRIER]: '手機條碼',
  [Invoice.DONATE_INVOICE]: '捐贈發票',
}
